<template>
  <v-data-table
    :headers="headers"
    :items="groupedPagamentoLotes"
  >
    <template v-slot:item.numeroNotaFiscal="{ item }">
      <b>{{ item.numeroNotaFiscal || '-' }}</b>
    </template>
    <template v-slot:item.numeroLote="{ item }">
      <b>{{ join(item.pagamentoLotes, 'numeroLote') }}</b>
    </template>
    <template v-slot:item.numeroProtocolo="{ item }">
      <b>{{ join(item.pagamentoLotes, 'numeroProtocolo') }}</b>
    </template>
    <template v-slot:item.valorInformado="{ item }">
      <b>R$ {{ sum(item.pagamentoLotes, 'valorInformado') | formatPrice }}</b>
    </template>
    <template v-slot:item.valorConciliado="{ item }">
      <b>R$ {{ (sum(item.pagamentoLotes, 'valorItensConciliacaoManual') + sum(item.pagamentoLotes, 'valorItensConciliacaoAutomatica')) | formatPrice }}</b>
    </template>
    <template v-slot:item.valorLiberado="{ item }">
      <b style="color: green">
        R$ {{ sum(item.pagamentoLotes, 'valorPago') | formatPrice }}
      </b>
      ({{ sum(item.pagamentoLotes, 'valorPago')/sum(item.pagamentoLotes ,'valorInformado') | formatPercent }})
    </template>
    <template v-slot:item.valorGlosado="{ item }">
      <b style="color: red">
        R$ {{ sum(item.pagamentoLotes, 'valorGlosado') | formatPrice }}
      </b>
      ({{ sum(item.pagamentoLotes, 'valorGlosado')/sum(item.pagamentoLotes, 'valorInformado') | formatPercent }})
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    groupedPagamentoLotes: { type: Array, required: true }
  },
  data () {
    return {
      headers: [
        {
          text: 'Nº nota fiscal',
          value: 'numeroNotaFiscal',
          align: 'right',
          class: 'py-0'
        },
        {
          text: 'Nº lote',
          value: 'numeroLote',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Protocolo',
          value: 'numeroProtocolo',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Valor apresentado',
          value: 'valorInformado',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Valor conciliado',
          value: 'valorConciliado',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Valor liberado',
          value: 'valorLiberado',
          align: 'right',
          class: 'py-0',
          sortable: true,
        },
        {
          text: 'Valor glosado',
          value: 'valorGlosado',
          align: 'right',
          class: 'py-0',
          sortable: true,
        }
      ]
    }
  },
  methods: {
    join (pagamentoLotes, field) {
      return pagamentoLotes
        .map(lote => lote[field])
        .join(', ')
    },
    sum (pagamentoLotes, field) {
      return pagamentoLotes.reduce((acc, lote) => {
        acc = acc + lote[field]

        return acc
      }, 0)
    }
  },
  filters: {
    formatPercent (value) {
      const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 })
      return formatter.format(value)
    }
  },
}
</script>
